import styled from 'styled-components';
import { Colors } from '~/config/Colors';
import Card from '~/pages/Sistema/componentes/Card';
import Button from "~/componentes/Button";
import { Scrollbars } from 'react-custom-scrollbars';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;

  .row {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin: 0;

    .col {
      padding: 0.5em;
    }
    
    .col.w1 {
      width: 5em;
    }
    .col.w2 {
      width: 10em;
    }
    .col.w3 {
      width: 15em;
    }
    .col.w4 {
      width: 20em;
    }
    .col.w5 {
      width: 25em;
    }
    .col.w6 {
      width: 30em;
    }

    .center {
      text-align: center;
    }
  }

  .content-os {
    background: ${Colors.Color13};
    width: 100%;
    height: 100%;
    border-radius: 1em;
    padding: 1.1em;

    .header {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      justify-content: space-between;

      .titulo {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        background: ${Colors.Color2};
        border-radius: 0.4em;
        padding: 0.15em 0.8em 0.15em 0.3em;
        width: fit-content;

        img {
          width: 1.4em;
        }

        .title {
          font-size: 0.8125em;
          font-weight: 700;
          color: ${Colors?.Color7};
          margin-left: 0.5em;
        }
      }

      .div-right {
        display: flex;
        align-items: center;
        flex-direction: row;
        justify-content: flex-end;
        height: fit-content;

        .pagination {
          margin-left: 1em;
          display: flex;
          align-items: center;
          flex-direction: row;
          justify-content: flex-end;
          height: fit-content;
        }

        .btn-excel, .btn-pdf {
          height: 1.8em;
          width: 1.8em;
          padding: 0em;
          font-size: 0.88em;
          font-weight: 600;
          background: ${Colors.Color4};
          border: 0.25em solid ${Colors.Color4};
          border-radius: 0.4em;
          color: #FFFFFF;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 1em;

          img {
            width: 1em;
          }
        }
      }

      .div-icone {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        background: ${Colors.Color2};
        border-radius: 0.4em;
        padding: 0.15em 0.8em 0.15em 0.3em;
        width: fit-content;
        margin-bottom: 1.5em;

        img {
          width: 1.4em;
        }

        .title {
          font-size: 0.7125em;
          font-weight: 700;
          color: ${Colors?.Color7};
          margin-left: 0.5em;
        }
      }
    }

    .filtro {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      width: 100%;
      margin-top: 0.5em;
      margin-bottom: 1em;

      .item {
        width: 10em;
        margin-left: 0.6em;

        select {
          width: 100%;
        }
      }
    }

    .body {
      height: calc(100% - 5em) !important;

      .card-header {
        background: ${Colors.Color2};

        p {
          font-weight: 700;
          color: ${Colors?.Color4};
        }
      }
    }
  }
`;

export const ThisCard = styled(Card)`
  margin-bottom: 0.7em;
  padding: 0.8em;
  border-radius: 1em;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: fit-content;
  height: fit-content;
  position: relative;
  overflow: hidden;
  background: ${localStorage.getItem("tema") == "E" ? Colors.Color26 : Colors.Color2};
  box-shadow: none !important;

  ${props => {
    if (props?.ativo) {
      return `border: 0.1em solid ${Colors.Color8};`;
    }
  }}

  .row {
    .col {
      p {
        font-size: 0.7em;
        font-weight: bold;
        color: ${Colors.Color14};
        
        -webkit-box-orient: vertical;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
      }
    }
  }
`;

export const ThisProgress = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  content: "";
  width: ${props => props?.width};
  height: 1em;
  border-radius: 1em;
  background: ${props => props?.backgound};
`;

export const ScrollOS = styled(Scrollbars)`
  width: calc(100%) !important;
`;

export const PageButtonNumber = styled(Button)`
  position: relative;
  background: none;
  border: none;
  font-size: 0.9em;
  padding: 0.1em 0.7em;
  margin-left: 0.25em;
  margin-right: 0.25em;

  ${(props) => {
    if (props?.ativo) {
      return `
        color: ${Colors.Color13};
      `;
    } else {
      return `
        color: ${Colors.Color13};
      `;
    }
  }}

  :hover {
    color: ${Colors.Color13};

    p {
      color: ${Colors.Color13};
    }
  }

  ${(props) => {
    if (props?.ativo) {
      return `
        span {
          position: absolute;
          content: "";
          display: block;
          background: ${Colors.Color4};
          width: 100%;
          height: 100%;
          margin-left: -0.7em;
          margin-top: -0.1em;
          border-radius: 0.5em;
          transition: 1s;
        }
      `;
    } else {
      return `
        span {
          position: absolute;
          display: none;
          content: "";
          width: 0;
          height: 0;
          transition: 1s;
        }

        p {
          color: ${Colors.Color14};
        }
      `;
    }
  }}

  :hover span {
    display: block;
    background: ${Colors.Color4};
    width: 100%;
    height: 100%;
    margin-left: -0.7em;
    margin-top: -0.1em;
    border-radius: 0.5em;
  }

  p {
    position: relative;
  }
`;

export const PageButtonIcon = styled(Button)`
  background: ${Colors.Color1};
  width: 1.3em;
  height: 1.3em;
  border-radius: 0.3em;
  border: none;
  color: ${Colors.Color4};
  font-size: 0.8em !important;
  margin-left: 0.25em;
  margin-right: 0.25em;

  :hover {
    background: ${Colors.Color4};
    color: ${Colors.Color13};
  }
`;
